<template>
  <div class="form-group">
    <div class="form">
      <label style="width: 250px;">
        <input type="checkbox" v-model="parallaxActive" @change="changeValue" @keyup="changeValue">
        {{ $t('ct-active') }}
      </label>
      <label v-show="parallaxActive===true">
        {{ $t('ct-parallax-effect') }}
        <select v-model="parallaxEffect" class="custom-input form-control" @change="changeValue" @keyup="changeValue">
          <option value="scroll">{{ $t('ct-parallax-effect-scroll') }}</option>
          <option value="scale">{{ $t('ct-parallax-effect-scale') }}</option>
          <option value="opacity">{{ $t('ct-parallax-effect-opacity') }}</option>
          <option value="scroll-opacity">{{ $t('ct-parallax-effect-scroll-opacity') }}</option>
          <option value="scale-opacity">{{ $t('ct-parallax-effect-scale-opacity') }}</option>
        </select>
      </label>
      <label v-show="parallaxActive===true">
        {{ $t('ct-parallax-speed') }}
        <input type="number" min="-10" max="20" v-model="parallaxSpeed" class="custom-input form-control"
               @change="changeValue"
               @keyup="changeValue">
      </label>
    </div>
  </div>
</template>
<script>
	export default {
		name: 'ParallaxComponent',
		data() {
			return {
				element: null,
				parallaxActive: false,
				parallaxEffect: 'scroll',
				parallaxSpeed: 20,
				labelDesc: 'opa',
				callback: null,
			}
		},
		methods: {
			changeValue() {

				if (this.parallaxSpeed > 20)
					this.parallaxSpeed = 20;

				if (this.parallaxSpeed < -10)
					this.parallaxSpeed = -10;


				let response = {
          parallaxActive: this.parallaxActive,
          parallaxEffect: this.parallaxEffect,
          parallaxSpeed: this.parallaxSpeed,
        }

				this.callback(response);
			},
			setValues(obj) {

				this.parallaxActive = obj.parallaxActive;
				this.parallaxEffect = obj.parallaxEffect;
				this.parallaxSpeed = obj.parallaxSpeed;

				this.element = obj.element;
				this.labelDesc = this.$t(`ct-${obj.labelDesc}`);
				this.callback = obj.callback;
			}
		}
	}
</script>
<style scoped lang="scss">
  .form-group {
    overflow: hidden;
  }
</style>



// WEBPACK FOOTER //
// src/components/editor/resource_components/Parallax.vue